import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { waLink } from "../lib/whatsapp";

const plans = [
  {
    name: "Serveur / Serveuse",
    price: "50 €",
    unit: "/heure",
    features: [
      "Tenue d'apparat : chemise blanche, gilet noir, nœud papillon",
      "Service à l'assiette et au plateau",
      "Installation, service et rangement",
      "Équipe mixte, hommes et femmes",
    ],
    message: "Bonjour FK Conseil & Événement, je souhaite réserver des serveurs/serveuses (50 €/heure) pour mon événement.",
    testid: "pricing-card-server",
    featured: false,
  },
  {
    name: "Maître d'hôtel",
    price: "70 €",
    unit: "/heure",
    features: [
      "Coordination de toute la brigade",
      "Accueil protocolaire de vos invités",
      "Gestion du timing et du service",
      "Interlocuteur unique pendant l'événement",
    ],
    message: "Bonjour FK Conseil & Événement, je souhaite réserver un maître d'hôtel (70 €/heure) pour mon événement.",
    testid: "pricing-card-maitre",
    featured: true,
  },
  {
    name: "Événement sur mesure",
    price: "Sur devis",
    unit: "",
    features: [
      "Brigade complète pour grandes réceptions",
      "Événements sur plusieurs jours",
      "Conférences, galas et cérémonies officielles",
      "Étude personnalisée de votre besoin",
    ],
    message: "Bonjour FK Conseil & Événement, je souhaite un devis sur mesure pour mon événement.",
    testid: "pricing-card-custom",
    featured: false,
  },
];

export const Tarifs = () => (
  <section id="tarifs" data-testid="pricing-section" className="bg-[#f9f8f6] px-6 py-28 text-[#0a0a0a] lg:px-10 lg:py-40">
    <div className="mx-auto max-w-7xl">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-[#aa8c2c]"
      >
        Packs &amp; tarifs
      </motion.p>
      <div className="mb-24 flex flex-wrap items-end justify-between gap-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="max-w-2xl font-display text-4xl leading-tight tracking-tight sm:text-5xl lg:text-6xl"
        >
          Des tarifs clairs, <em className="italic text-[#aa8c2c]">sans surprise.</em>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="max-w-xs text-sm leading-relaxed text-[#0a0a0a]/50"
        >
          Mise à disposition à l'heure, selon la taille de votre événement.
          Devis et réponse rapide sur WhatsApp.
        </motion.p>
      </div>
      <div className="grid gap-8 lg:grid-cols-3">
        {plans.map((p, i) => (
          <motion.article
            key={p.testid}
            data-testid={p.testid}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className={`flex flex-col rounded-3xl border p-10 transition-transform duration-300 hover:-translate-y-2 ${
              p.featured
                ? "grain relative border-transparent bg-[#0a0a0a] text-white shadow-2xl"
                : "border-[#0a0a0a]/10 bg-white"
            }`}
          >
            {p.featured && (
              <span className="mb-6 inline-flex w-fit rounded-full bg-gold px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-[#0a0a0a]">
                Le plus demandé
              </span>
            )}
            <h3 className="font-display text-2xl tracking-tight">{p.name}</h3>
            <p className="mt-6 flex items-baseline gap-1">
              <span className={`font-display text-6xl font-light ${p.featured ? "text-gold" : "text-[#aa8c2c]"}`}>
                {p.price}
              </span>
              {p.unit && <span className={`text-sm ${p.featured ? "text-white/50" : "text-[#0a0a0a]/40"}`}>{p.unit}</span>}
            </p>
            <ul className="mt-8 flex-1 space-y-4">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm leading-relaxed">
                  <Check className={`mt-0.5 h-4 w-4 shrink-0 ${p.featured ? "text-gold" : "text-[#aa8c2c]"}`} />
                  <span className={p.featured ? "text-white/70" : "text-[#0a0a0a]/60"}>{f}</span>
                </li>
              ))}
            </ul>
            <a
              href={waLink(p.message)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${p.testid}-cta`}
              className={`mt-10 block rounded-full py-4 text-center text-xs font-bold uppercase tracking-[0.25em] transition-transform duration-300 hover:scale-[1.03] ${
                p.featured
                  ? "bg-gold text-[#0a0a0a]"
                  : "border border-[#0a0a0a]/20 text-[#0a0a0a] hover:border-[#aa8c2c] hover:text-[#aa8c2c]"
              }`}
            >
              Réserver sur WhatsApp
            </a>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
